module.exports = __webpack_public_path__ + "static/img/xiaochengxu2.83af491.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiaochengxu2.jpg
// module id = 576f
// module chunks = 41